import api from './api';

export function getUserLicences(id) {
    return api.get(`/users/${id}/licences`);
}

export function create(params) {
    return api.post(`licences`, params);
}

export function getAll() {
    return api.get(`/licences`);
}

export function getOne(id) {
    return api.get(`/licences/${id}`);
}

export function update(params) {
    return api.put(`/licences/${params.id}`, params);
}

export function remove(id) {
    return api.delete(`/licences/${id}`);
}

export function getServiceLicence(serviceId, licenceType) {
    return api.get(`/services/${serviceId}/licences/${licenceType}`);
}